import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import { SearchAllProjects } from '../../../../components';
import { SCREEN_NORMAL, SEARCHKIT_HITS_PER_PAGE_ALL_PROJECTS } from '../../../../config/constants';

export interface ParagraphMapSearchViewProps {
  wrapperWidth: number;
}

const ParagraphMapSearchView: React.FC<ParagraphMapSearchViewProps> = (props) => {
  const { wrapperWidth } = props;

  const { t } = useTranslation();

  const showSidebar = useMemo(() => (
    wrapperWidth >= SCREEN_NORMAL
  ), [wrapperWidth]);

  return (
    <SearchAllProjects hitsPerPage={SEARCHKIT_HITS_PER_PAGE_ALL_PROJECTS as number}>
      <Container>
        <div className="row">
          {showSidebar ? (
            <>
              <div className="col-3 col-lg-5">
                <h2 className="mb-2">{t('components.search_all_projects.title')}</h2>
              </div>

              <div className="col-9 col-lg-6 offset-lg-1">
                <SearchAllProjects.Facets />
              </div>

              <div className="col-12">
                <SearchAllProjects.Results />
              </div>
            </>
          ) : (
            <div className="col-12">
              <SearchAllProjects.Facets forceDialog />
              <h2 className="mb-2">{t('components.search_all_projects.title')}</h2>
              <SearchAllProjects.Results />
            </div>
          )}
        </div>
      </Container>
    </SearchAllProjects>
  );
};

export default ParagraphMapSearchView;
